<template>
  <div class="footprint-page-content">
    <!-- 产品列表 -->
    <div v-loading="loading">
      <div class="prod-list-area" v-if="dataSource.length">
        <div class="prod-list-content">
          <!-- <div class="prod-list-block">
            <card-list :data="item" :type="cardListType" v-for="(item, index) of dataSource" :key="index"></card-list>

            <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
          </div> -->
           <div
              class="prod-list-block"
              v-for="(item, index) of dataSource"
              :key="index"
            >
            <card-list :data="item" :type="cardListType"></card-list>
          </div>
          <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
        </div>
      </div>
      <el-empty description="暂无数据" v-else></el-empty>
    </div>
    <div class="list-pagination">
      <md-page :page="page" :total="count" :pageSize="pageSize" @pagecallback="handleCurrentChange"></md-page>
    </div>
  </div>
</template>

<script>
import { UserService } from "@/service";
import CardList from "@/components/card-list.vue";

export default {
  components: {
    CardList,
  },
  data() {
    return {
      activeName: this.$router.history.current.params.type || '',
      page: 1,
      pageSize: 50,
      count: 0,
      loading: false,
      dataSource: [],
      tabs: [
        { key: 'prod', name: '我浏览过的产品' },
        { key: 'comp', name: '我浏览过的企业' },
        { key: 'down', name: '我下载过的产品' },
      ],
    };
  },
  computed: {
    cardListType() {
      return this.activeName === 'down' ? 'prod' : this.activeName;
    }
  },
  watch: {
    $route(to, from){
      this.activeName = to.params.type;
      this.getDataSource();
    },
  },
  methods: {
    async getDataSource(page = 1) {
      this.loading = true;
      if (page === 1) {
        this.page = 1;
      } else {
        this.dataSource = [];
      }
      const urlObj = {
        prod: 'viewProdLogsForUser',
        comp: 'viewCompLogsForUser',
        down: 'downProdLogsForUser',
      };
      let url = urlObj[this.activeName];
      const res = await UserService[url](page, this.pageSize);
      if (res.code === 0) {
        let { count, list = [] } = res.data;

        // list = list.filter(item => {
        //   return item.CompID !== undefined
        // });

        this.dataSource = list;
        this.count = count || 0;
      }
      this.loading = false;
    },
    // 分页搜素
    handleCurrentChange(_page) {
      this.page = _page.page;
      this.getDataSource(this.page);
    },
  },
  mounted() {
    this.getDataSource();
  },
};
</script>
<style lang="less" scoped>

.prod-list-content {
  display: flex;
  flex-wrap: wrap;
}
.prod-list-block {
  min-width: 150px;
  max-width: 180px;
  margin: 0 5px 10px 5px;
  flex: 1;
  border: 1px solid #d6d6d6;
  position: relative;
}

.list-pagination {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 8px;
}
</style>